import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CpfMaskDirective } from './directives/cpf-mask.directive';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { MoneyMaskDirective } from './directives/money-mask.directive';
import { CepMaskDirective } from './directives/cepMask/cep-mask.directive';
import { MaterialModule } from '../material/material.module';

@NgModule({
  declarations: [CpfMaskDirective, PhoneMaskDirective, MoneyMaskDirective, CepMaskDirective],
  imports: [CommonModule, MaterialModule],
  exports: [CpfMaskDirective, PhoneMaskDirective, MoneyMaskDirective, CepMaskDirective],
})
export class SharedModule {}
